import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AssignDialogComponent } from 'src/app/common/assign-dialog/assign-dialog.component';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { printMessage } from 'src/app/constants/service.constants';
import { RouteComponent } from 'src/app/common/route/route.component';
import { WithdrawComponent } from 'src/app/common/withdraw/withdraw.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { IstDataShareService } from '../../services/ist/ist-datashare.service';
import { IST_APP, ModuleMenu } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { UserService } from 'src/app/services/user.service';
import { EapUserInstructionsModalComponent } from './eap-user-instructions-modal/eap-user-instructions-modal.component';
import { EapSummaryService } from '../../services/eap/eap-summary.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-eap-my-applications',
  templateUrl: './eap-my-applications.component.html',
  styleUrls: ['./eap-my-applications.component.scss']
})
export class EapMyApplicationsComponent implements OnInit {

  gridApi: GridApi;
  columnDefs: any[];
  operations: any[];
  tempoperations: any[];
  rowData;
  advanceSearch1: any;
  selectedRow;
  caseDetails;
  requestType: any[];
  ProductsList: any[];
  StatusList: any[];
  EAPApplicationsSearch: UntypedFormGroup;
  istapp: IST_APP;
  menudata: ModuleMenu;
  userType: string = "";
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: EapSummaryService,
    private modalService: NgbModal,
    private dataShare: IstDataShareService,
    private commonService: CommonService,
    private header: HeadService,
    private userService: UserService

  ) {

  }

  ngOnInit() {
    this.StatusList = [{ "value": "", "label": "All" },{ "value": "0", "label": "Draft" }, { "value": "2", "label": "Submitted" }, { "value": "3", "label": "Review Ongoing" }, { "value": "4", "label": "Accepted" }, { "value": "5", "label": "Closed" }, { "value": "6", "label": "Reject" }, { "value": "7", "label": "Onhold" }, { "value": "8", "label": "Withdrawn" }, { "value": "9", "label": "Discard" }, { "value": "10", "label": "Assign" }];
    this.userType = this.userService.getUserType();
  
    this.EAPApplicationsSearch = new UntypedFormGroup({
      PhysicianName: new UntypedFormControl(""),
      Product: new UntypedFormControl(""),
      EapType: new UntypedFormControl(""),
      Status: new UntypedFormControl(""),
      ApplicationID: new UntypedFormControl(""),
    });
    this.columnDefs = [
      {
        "headerName": "Application ID",
        "field": "APPLICATION_CODE"
      },
      {
        "headerName": "EAP Type",
        "field": "EAPType",
        "sort": "asc"
      },
      {
        "headerName": "Physician Name",
        "field": "PhysicianName"
      },
      {
        "headerName": "Submitted On",
        "field": "SubmittedOnStr"
      },
      {
        "headerName": "Status",
        "field": "STATUSStr"
      },
     
      {
        "headerName": "Assigned To",
        "field": "AssignedTo"
      },
     
    ];
  //  if (this.userType === "E") {

      this.tempoperations = [
        {
          "name": "New Application",
          "id": "add"
        }
      ]
   // }
  //  else
  //    this.tempoperations = [];

    this.operations = this.tempoperations.map(operation => {
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    this.advanceSearch1 = {
    };


    this.caseDetails = [
      {
        "caseSet": {
          "caseHeading": "General",
          "caseData": [
            {
              "label": "Application ID",
              "value": "APPLICATION_CODE"
            },
            {
              "label": "EAP Type",
              "value": "EAPType"
            },
            {
              "label": "Physician Name",
              "value": "PhysicianName"
            },
            {
              "label": "Status",
              "value": "STATUSStr"
            },
            {
              "label": "Submitted On",
              "value": "SubmittedOnStr"
            },
            {
              "label": "Last Updated Date",
              "value": "LastUpdatedStr"
            },
            {
              "label": "IRB Name",
              "value": "IRBName"
            },
            {
              "label": "Assigned To",
              "value": "AssignedTo"
            }
          ]

        }
      }
    ];

    this.getSummaryData();
  }


  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    debugger;
    this.summaryService.getISTApplicationSummary("api/common/geteapapp/" + event.data["ID"]).subscribe(data => {
      debugger;
      this.istapp = data;
      this.commonService.setEAPApp(this.istapp);
      this.commonService.appId = data.ID;

      this.menudata = new ModuleMenu();
      this.menudata.module = "EAP";
      this.menudata.operation = "Edit";
      this.menudata.appId = this.istapp.ID;
      if (this.istapp.STATUS === null)
        this.menudata.formstate = "Draft";
      else
        this.menudata.formstate = this.getStatus(this.istapp.STATUS);
      this.commonService.setModluleMenu(this.menudata);

      this.header.setHeader(this.menudata);
      this.dataShare.setApplicationID(event.data["ID"]);
      this.router.navigate(['/home/eap/my-applications/application-ext/:' + event.data['ID'] + '/program_info'], { skipLocationChange: true, queryParams: { id: event.data['ID'], app_ext: true, module: "eap",submodule:"eap", screen_type: "my-applications" } })
    });

    //let url = location.href.split('/');
    //window.open(url[0] + '//' + url[2] + '/home/ist/my-applications/application-ext/:' + this.selectedRow['id']+'/general_information_request');
  }


  getStatus(statusnum: number): string {
    let status = "";
    switch (statusnum) {
      case 0:
        status = "Draft";
        break;
      case 1:
        status = "Draft";
        break;
      case 2:
        status = "Submitted";
        break;
      case 3:
        status = "Review Ongoing";
        break;
      case 4:
        status = "Accepted";
        break;
      case 5:
        status = "Closed";
        break;
      case 6:
        status = "Reject";
        break;
      case 7:
        status = "Onhold";
        break;
      case 8:
        status = "Withdrawn";
        break;
      case 9:
        status = "Discard";
        break;
      case 10:
        status = "Assign";
        break;
    }
    return status;
  }

  assign() {
    this['self'].modalRef = this['self'].modalService.show(AssignDialogComponent, { class: 'modal-md modal-full-height modal-right' });
  }

  print() {
    this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
      data: {
        operation: { hasOpr: false },
        heading: 'Print Application',
        content: { heading: '', description: printMessage }
      }
    });
  }
  withdraw() {
    this['self'].modalService.show(WithdrawComponent, { class: 'modal-lg modal-full-height modal-right' });
  }

  onHold() {
    // let modalRef = this['self'].modalService.show(RejectComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   ignoreBackdropClick: true,
    //   class: 'modal-md modal-full-height modal-right',
    //   animated: true,
    //   data: {
    //     heading: 'On-Hold',
    //     content: null
    //   }
    // });
  }

  routeModal() {
    this['self'].modalService.show(RouteComponent, { class: 'modal-md modal-full-height modal-right' });
  }

  return() {
   // this['self'].modalService.show(ReturnComponent, { class: 'modal-md modal-full-height modal-right' });
  }

  discard() {

  }

  add() {
    this['self'].modalService.show(EapUserInstructionsModalComponent, {
      backdrop: false,
      keyboard: false,
      ignoreBackdropClick: true,
      class: 'modal-vlg modal-full-height modal-right',
      animated: true,
      data: {
        id: ""
      }
    })
  }

  getSummaryData() {
    this.SearchClear();
    this.summaryService.getApplicationSummary("api/EAPGeneralInfo/GetMyEAPApplicationsList").subscribe(summary => {
      this.rowData = summary["SummaryData"];
      //  this.requestType = summary["MasterDrops"].MasterData1;
      this.requestType=[{label : "All" , value: ""}].concat(summary["MasterDrops"].MasterData1);
      //this.ProductsList = summary["MasterDrops"].MasterData2;
       this.ProductsList=[{label : "All" , value: ""}].concat(summary["MasterDrops"].MasterData2);  
    });
  }
  getSummarySearch(searchObject: any) {
    this.summaryService.getISTSearchSummary("api/EAPGeneralInfo/getEapSummarySearch", searchObject).subscribe(summary => {
      this.rowData = summary["SummaryData"];
    });
  }

  //// Advace search Functions
  SearchClear() {
    this.EAPApplicationsSearch.reset();
  }
  AdvanceSearch() {
    var formData = this.EAPApplicationsSearch.value;
    this.getSummarySearch(formData);
  }
}
